<script setup>
import PanelOrganic from '@/design/primitives/PanelOrganic.vue'

defineProps({
  kicker: { type: String, default: '' },
  stamp:  { type: String, default: '' }
})
</script>

<template>
  <div class="gate">
    <div class="gate__inner">
      <!-- Kicker above panel -->
      <p v-if="kicker" class="gate__kicker u-display u-allcaps u-gold">{{ kicker }}</p>

      <!-- Main glass panel -->
      <PanelOrganic tone="strong" :grain="true" :padded="true" class="gate__panel u-rise-in">
        <slot />
      </PanelOrganic>

      <!-- Stamp below panel -->
      <p v-if="stamp" class="gate__stamp u-display u-allcaps">"{{ stamp }}"</p>
    </div>
  </div>
</template>

<style scoped>
.gate {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-block: var(--sp-24);
  padding-inline: var(--sp-4);
}

@media (max-width: 719px) {
  .gate {
    padding-block: var(--sp-16);
  }
}

.gate__inner {
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--sp-4);
}

.gate__kicker {
  margin: 0;
  font-size: var(--fs-12);
  letter-spacing: 0.14em;
  text-align: center;
}

.gate__panel {
  width: 100%;
  /* Layered shadows: glass ambient + gold edge + deep lift */
  box-shadow:
    var(--shadow-glass),
    var(--shadow-gold-edge),
    var(--shadow-3);
}

.gate__stamp {
  margin: 0;
  font-size: var(--fs-12);
  color: var(--gold);
  opacity: 0.55;
  letter-spacing: 0.10em;
  text-align: center;
}
</style>
